import RequestAbstract from "../abstract";

export default class PayoutInstances extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payout-instances";
    }

    /**
     * Manually confirm a stuck payout — the operator asserting what happened.
     *
     * `text` is the transfer reference and is required: the decision leaves no gateway
     * trace, so it is the only account of it. `receipt`, optional, is the bank's proof
     * of it: `{ contentType, content }`, the file's bytes as base64. Without one the
     * key is left out rather than sent empty. `walletId` is the card the money left
     * from, which a payout with no wallet yet must name (its gateway names the card at
     * confirmation); left out otherwise.
     */
    async confirm(id, text, receipt, walletId) {
        const body = { text };
        if (receipt) body.receipt = receipt;
        if (walletId != null) body.walletId = walletId;
        return await this.post(`${this.link}/${id}/confirm`, body);
    }

    /** Manually reject a stuck payout. `text` is the reason, and is required. */
    async reject(id, text) {
        return await this.post(`${this.link}/${id}/reject`, { text });
    }
}
